import { useContext } from 'react';
import PermissionsContext, { PermissionsBase } from 'src/careflow/ph-core/admin/permissions/context/PermissionsContext';

const usePermissionsContext = <T extends PermissionsBase>(): T | null =>
  useContext(PermissionsContext) as T | null;

export default usePermissionsContext;
